// extracted by css-extract-rspack-plugin
export default {"hist":"TaskPreview_hist__8t-3e"};